import React, { Component } from 'react';
import styled from 'styled-components';
import { format, isBefore, isAfter, isEqual, closestTo, getDay } from 'date-fns'
import moment from 'moment-timezone'
import { DnDContext } from '../DnDContext'
import { momentDate, timezoneDate } from 'utils'
import Droppable2 from './Droppable2'

const Container = styled.div`
    /* border: ${props => props.isOver ? '1px solid var(--focus-color)' : '1px solid transparent'}; */
    border-style: ${props => props.styles.borderStyle};
    border-color: ${props => props.styles.borderColor};
    border-width: ${props => props.styles.borderWidth};
    border-radius: ${props => props.styles.borderRadius};
    background-color: ${props => props.styles.backgroundColor};
    background-color: ${props => props.backgroundColor};
    width: 100%;
    height: calc(100% - 1px);
    flex-grow:4;
    position: ${props => props.position};
    /* border-right: 1px solid var(--primary-accent-color); */
    /* min-height: 10rem; */
    box-sizing: border-box;
    /* border: 1px solid red; */
`

class DateCellWrapper extends Component {
    static contextType = DnDContext;

    getStyles = () => {
        const { draggable, slotHandlers, extraProps } = this.context
        const {
            children,
            range,
            value,
        } = this.props

        const selectedSchedule = extraProps['selected']
        const timezone = extraProps['timezone']
        let selected = false
        let styles = {}
        styles['borderStyle'] = 'solid'
        styles['borderColor'] = 'var(--primary-accent-color)'

        if(timezoneDate(value, timezone).day() === 0){ // [TODO] Direct to settings of selected first day, default is Sunday
            styles['borderWidth'] = '0 1px 1px 1px'
        } else {
            styles['borderWidth'] = '0 1px 1px 0'
        }

        if(selectedSchedule){
            const isStart = isEqual(value, selectedSchedule['start_date']) 
            const isEnd = isEqual(value, selectedSchedule['end_date']) 
            const moreStart = isAfter(value, selectedSchedule['start_date'])
            const lessEnd = isBefore(value, selectedSchedule['end_date'])
            const calendarStyles = extraProps['styles']
            if(isStart | isEnd){
                selected = true
                styles['backgroundColor'] = calendarStyles ? calendarStyles['secondaryColor'] : 'var(--secondary-color)'
                // styles['borderStyle'] = 'solid'
                // styles['borderColor'] = 'var(--focus-color)'
                styles['borderRadius'] = isStart & isEnd ? '5px'
                                        : isStart ? '5px 0 0 5px'
                                        : isEnd ? '0 5px 5px 0'
                                        : null
                // styles['borderWidth'] = isStart & isEnd ? '2px'
                //                         : isStart ? '2px 0 2px 2px' 
                //                         : isEnd ? '2px 2px 2px 0'
                //                         : null
            } else if(isBefore(value, selectedSchedule['end_date']) & isAfter(value, selectedSchedule['start_date'])){
                selected = true
                styles['backgroundColor'] = calendarStyles ? calendarStyles['secondaryColor'] : 'var(--secondary-color)'
                // styles['borderStyle'] = 'solid'
                // styles['borderColor'] = 'var(--focus-color)'
                // styles['borderWidth'] = '2px 0 2px 0'
            }
        }
        return {selected: selected, styles: styles}
    }

    ///////////////////
    // Slot handlers //
    ///////////////////
    onSlotDown = (id, event) => {
        const { draggable, slotHandlers, extraProps } = this.context
        const selected = extraProps['selected']
        let schedule = {
            start_date: id,
            start_time: null,
            end_date: id,
            end_time: null
        }
        slotHandlers.onSlotDown && slotHandlers.onSlotDown(schedule, event)
    }

    onSlotHover = (id, event) => {
        const { draggable, slotHandlers, extraProps } = this.context
        const selected = extraProps['selected']
        const slot = extraProps['slot']
        if(selected && selected['start_date']){
            let schedule = {...selected}
            if(isBefore(id, schedule['start_date'])){
                schedule['start_date'] = id
            } else if(isAfter(id, schedule['end_date'])){
                schedule['end_date'] = id
            } else if (isBefore(id, schedule['end_date']) & isAfter(id, schedule['start_date'])) {
                const closest = closestTo(slot, [schedule['start_date'], schedule['end_date']])
                if(isEqual(closest, schedule['end_date'])){
                    schedule['end_date'] = id
                } else if (isEqual(closest, schedule['start_date'])){
                    schedule['start_date']  = id
                }
            } else {
                schedule['start_date'] = id
                schedule['end_date'] = id
            }
            slotHandlers.onSlotHover && slotHandlers.onSlotHover(schedule, event, id)
        }
    }

    onSlotUp = (event) => {
        const { draggable, slotHandlers, extraProps } = this.context
        slotHandlers.onSlotUp && slotHandlers.onSlotUp()
    }

    render() {
        const {
            children,
            resource,
            value,
            key
        } = this.props;

        const result = this.getStyles()
        const { draggable, slotHandlers, extraProps } = this.context
        const selected = extraProps['selected']
        const mouseDown = extraProps['mouseDown']
        const hover = selected ? selected['start_date'] : false

        const id = `CALENDAR_${moment(value).format('YYYY-MM-DD')}`
        const ref = this.context['extraProps']['refs'][value.getHours()]
        return (
            <Container styles={result['styles']} ref={ref}
                onSlotDown={this.onSlotDown}
                onSlotHover={mouseDown && this.onSlotHover}
                onSlotUp={this.onSlotUp}>
                <Droppable2 id={id} boundingRect={ref.current && ref.current.getBoundingClientRect()} extraProps={extraProps}>
                    {this.props.children}
                </Droppable2>
            </Container>
        )
    }
}

export default DateCellWrapper;
